import { render, staticRenderFns } from "./CopyInspectionSentModal.vue?vue&type=template&id=cffb4188&"
import script from "./CopyInspectionSentModal.vue?vue&type=script&lang=js&"
export * from "./CopyInspectionSentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports